import { RefreshableItem } from '../../models/refreshableItem';

const validTransactionsRefreshableItems = [
  RefreshableItem.CHECKING_ACCOUNTS,
  RefreshableItem.CHECKING_TRANSACTIONS,
  RefreshableItem.SAVING_ACCOUNTS,
  RefreshableItem.SAVING_TRANSACTIONS,
  RefreshableItem.CREDITCARD_ACCOUNTS,
  RefreshableItem.CREDITCARD_TRANSACTIONS,
];

export const getTransactionsRefreshableItems = (
  refreshableItemsUrlParameter: string | undefined
) => {
  return refreshableItemsUrlParameter
    ? (refreshableItemsUrlParameter.split(',') as RefreshableItem[])
    : validTransactionsRefreshableItems;
};

export const getInvalidTransactionsRefreshableItems = (
  refreshableItemsUrlParameter: string | undefined
) => {
  let invalidRefreshableItems: RefreshableItem[] = [];

  if (!refreshableItemsUrlParameter) {
    return invalidRefreshableItems;
  }

  const queryRefreshableItems = refreshableItemsUrlParameter.split(',') as RefreshableItem[];

  invalidRefreshableItems = queryRefreshableItems.filter((queryRefreshableItem) => {
    return !validTransactionsRefreshableItems.includes(queryRefreshableItem);
  });

  return invalidRefreshableItems;
};
